import z from "zod/v4";

import { AiNodeContextSchema } from "./context-schemas";

export const UserInputTextSchema = z.object({
  type: z.literal("text"),
  content: z.string(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export type UserInputText = z.infer<typeof UserInputTextSchema>;

export const UserInputFileSchema = z.object({
  type: z.literal("file"),
  files: z.array(
    z.object({
      name: z.string(),
      size: z.number(),
      mediaType: z.string(),
      url: z.string(),
    })
  ),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export const UserInputChoiceSchema = z.object({
  type: z.literal("choice"),
  choice: z.string(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export const UserInputConfirmationSchema = z.object({
  type: z.literal("confirmation"),
  confirmed: z.boolean(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export const UserInputSchema = z.discriminatedUnion("type", [
  UserInputTextSchema,
  UserInputFileSchema,
  UserInputChoiceSchema,
  UserInputConfirmationSchema,
]);

export type UserInput = z.infer<typeof UserInputSchema>;

// Result of workflow execution
export const ExecutionErrorSchema = z.object({
  name: z.string(),
  message: z.string(),
  retryable: z.boolean().optional(),
  details: z.unknown().optional(),
});

export type ExecutionError = z.infer<typeof ExecutionErrorSchema>;
